import { PayoutMethod } from '@/types/api/payout-account';
import { useStore } from '@tanstack/react-form';
import FormInputField from '../ui/form-input-field';
import PayoutMethodRadio from './PayoutMethodRadio';
import ButtonGroup from './ButtonGroup';
import { FormProvider } from '@/contexts/form-context';
import { useBankAccountSelectionResult } from '@/hooks/payout-account/use-bank-account-selection-result';
import * as React from 'react';
import BankAccountSelectionButton from './BankAccountSelectionButton';
import { useCreatePayoutAccountForm } from '@/hooks/payout-account/use-create-payout-account.form';

interface CreatePayoutAccountFormProps {
  onSuccess: () => void;
}

export default function CreatePayoutAccountForm({ onSuccess }: CreatePayoutAccountFormProps) {
  const form = useCreatePayoutAccountForm(onSuccess);
  const { id: selectionId } = useBankAccountSelectionResult();

  React.useEffect(() => {
    if (selectionId) {
      form.setFieldValue('payoutMethod', PayoutMethod.BankTransfer);
      form.setFieldValue('selectionId', selectionId);
    }
  }, [selectionId]);

  const payoutMethod = useStore(form.store, (state) => state.values.payoutMethod);

  return (
    <FormProvider form={form}>
      <form
        className="space-y-8"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          form.handleSubmit();
        }}
      >
        <PayoutMethodRadio />

        {payoutMethod === PayoutMethod.Swish && <FormInputField name="swishNumber" label="Swishnummer" />}
        {payoutMethod === PayoutMethod.BankTransfer && <BankAccountSelectionButton />}

        <ButtonGroup />
      </form>
    </FormProvider>
  );
}
